export default __webpack_public_path__ + "static/media/map-europa.3ca76883.png";